import { defineStore } from 'pinia'

export const useOpacityOverlayStore = defineStore('opacityOverlay', () => {
  const opacityOverlay = ref(false)

  const setOpacityOverlay = (newValue: boolean) => {
    opacityOverlay.value = newValue
  }

  return { opacityOverlay, setOpacityOverlay }
})
